import { FC } from "react";

import { hasKeys } from "@ryde/shared";

import { MessagesDisplayContainerStyled } from "./messages-display.container.styled";
import { MessagesDisplayFormsContainer } from "./messages-display.forms.container";
import {
  IMessagesDisplayContainer,
  IMessagesTypeEnum,
} from "./messages-display.models";
import { MessagesDisplayServerContainer } from "./messages-display.server.container";
import { MessagesIndicatorConst } from "./messages-display.utils";

export const MessagesDisplayContainer: FC<IMessagesDisplayContainer> = ({
  serverMessages,
  formMessages,
  marginInlineStart,
  type = IMessagesTypeEnum.ERROR,
}) => {
  const hasServerMessages = !!serverMessages?.length;
  const hasFormMessages = hasKeys(formMessages);
  const hasMessages = hasServerMessages || hasFormMessages;

  const { $bgColor } = MessagesIndicatorConst[type];

  return (
    hasMessages && (
      <MessagesDisplayContainerStyled
        $marginInlineStart={marginInlineStart}
        className="messages-display-container"
        $bgColor={$bgColor}
        aria-live="polite"
        aria-atomic="true"
      >
        <MessagesDisplayServerContainer
          serverMessages={serverMessages}
          type={type}
        />
        <MessagesDisplayFormsContainer
          formMessages={formMessages}
          type={type}
        />
      </MessagesDisplayContainerStyled>
    )
  );
};
